module.exports = __webpack_public_path__ + "static/media/flexform.89c85776.png";